import type { z } from "zod";
import type { ValidationError } from "./validationError";

export const ServiceErrorCode = {
  MALFORMED_INPUT: "MALFORMED_INPUT",
  MALFORMED_RESPONSE: "MALFORMED_RESPONSE",
  SERVICE_ERROR: "SERVICE_ERROR",
  VALIDATION_ERROR: "VALIDATION_ERROR",
} as const;

export type ServiceErrorCode =
  (typeof ServiceErrorCode)[keyof typeof ServiceErrorCode];

/**
 * Non-polymorphic error payload. Prefer named fields over union discrimination.
 * HTTP status lives on ServiceErrorExtension.statusCode.
 */
export type ServiceErrorDetails = {
  issues?: z.core.$ZodIssue[];
  validationErrors?: ValidationError[];
  error?: string;
};

export type ServiceErrorExtension = {
  code: string;
  statusCode: number;
  details?: ServiceErrorDetails;
};

export class ServiceError extends Error {
  extensions?: ServiceErrorExtension;
  error?: Error;

  constructor(
    message: string,
    extensions: ServiceErrorExtension,
    error?: Error,
  ) {
    super(message);
    this.name = "Service Error";
    this.extensions = extensions;
    this.error = error;
    Object.setPrototypeOf(this, ServiceError.prototype);
  }
}
